// An illustrative calculation only. This code does not request or approve financing.
export function splitInstallments(unitPrice, quantity = 1) {
  if (!Number.isSafeInteger(unitPrice) || unitPrice <= 0 || !Number.isSafeInteger(quantity) || quantity <= 0) return null;
  const total = unitPrice * quantity;
  if (!Number.isSafeInteger(total)) return null;
  const base = Math.floor(total / 3);
  return [base, base, total - base * 2];
}

export function examplePaymentDates(now = new Date(), timeZone = 'Europe/Madrid') {
  const parts = new Intl.DateTimeFormat('en-CA', { timeZone, year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(now);
  const part = type => Number(parts.find(item => item.type === type)?.value);
  const day = Date.UTC(part('year'), part('month') - 1, part('day'), 12);
  return [0, 30, 60].map(offset => new Date(day + offset * 86400000));
}

class ODProductPayments extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    this.quantity = this.closest('.od-pdp')?.querySelector('product-form-component [name="quantity"]');
    this.quantity?.addEventListener('input', () => this.render(), { signal: this.controller.signal });
    this.quantity?.addEventListener('change', () => this.render(), { signal: this.controller.signal });
    document.addEventListener('visibilitychange', () => { if (!document.hidden) this.render(); }, { signal: this.controller.signal });
    this.render();
  }
  render() {
    const quantity = this.quantity ? Number(this.quantity.value) : 1;
    const parts = this.quantity?.validity?.valid === false ? null : splitInstallments(Number(this.dataset.unitPrice), quantity);
    const schedule = this.querySelector('.od-pdp__installments');
    const invalid = this.querySelector('[data-od-payment-invalid]');
    if (schedule) schedule.hidden = !parts;
    if (invalid) invalid.hidden = Boolean(parts);
    if (!parts) return;
    let money;
    try { money = new Intl.NumberFormat(this.dataset.locale || 'es-ES', { style: 'currency', currency: this.dataset.currency || 'EUR' }); }
    catch { money = new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }); }
    this.querySelectorAll('[data-od-installment]').forEach((node, index) => { node.textContent = money.format(parts[index] / 100); });
    const dates = examplePaymentDates(new Date(), this.dataset.timeZone || 'Europe/Madrid');
    const dateFormat = new Intl.DateTimeFormat(this.dataset.locale || 'es-ES', { timeZone: 'UTC', day: '2-digit', month: '2-digit', year: 'numeric' });
    this.querySelectorAll('[data-od-installment-date]').forEach((node, index) => {
      node.dateTime = dates[index].toISOString().slice(0, 10);
      node.textContent = dateFormat.format(dates[index]);
    });
  }
  disconnectedCallback() { this.controller?.abort(); }
}
if (!customElements.get('od-product-payments')) customElements.define('od-product-payments', ODProductPayments);
